import React from 'react';
import styles from '../../assets/styles/MimaCheckout/MimaCheckout.module.scss';
import Logo from '../../assets/img/mima-logo.png';
import {
	MimaButton,
	MimaText,
	MimaToastUtil,
	PageLoader,
} from '../../components';
import successImg from '../../assets/img/Successful.png';
import validateImg from '../../assets/img/Mimaweb.png';
import { MdOutlineContentCopy } from 'react-icons/md';
import { invoiceStore } from '../../stores';
import { amountFormatter } from '../../utils/utils';

const MimaCheckout = ({
	timeLeft,
	timedOut,
	validatePaymentClick,
	validatePay,
	chooseBank,
	setChooseBank,
	loading,
	paid,
	loading2,
}) => {
	const { accounts, invoice } = invoiceStore?.checkoutData;
	const bankList = accounts?.map(x => x.bank);

	return (
		<>
			{loading ? (
				<PageLoader title="while we load your checkout Info" />
			) : (
				<>
					{paid ? (
						<div className={styles.main}>
							<div className={styles.bizInfo}>
								<img src={Logo} alt="Mima Logo" />
							</div>
							<div className={styles.payInfo}>
								<img
									src={successImg}
									alt="Mima Logo"
									className={styles.successImg}
								/>
								<MimaText
									variant="h3"
									align="center"
									mb={1}
									mt={2}
									color="var(--color-success)">
									Payment Success
								</MimaText>
								<MimaText variant="subtitleBold" align="center" width={40}>
									Payment has been received for the invoice attached to this
									link.
								</MimaText>
							</div>
						</div>
					) : (
						<div className={styles.main}>
							<div className={styles.bizInfo}>
								<img src={Logo} alt="Mima Logo" />
								{!validatePay && (
									<div>
										<MimaText variant="bodyBold">
											{invoice?.business?.tradingName}
										</MimaText>
										<MimaText color="var(--color-green)">
											Pay{' '}
											{amountFormatter('NGN').format(
												invoice?.deposit + (invoice?.customerProcessingFee || 0)
											)}
										</MimaText>
									</div>
								)}
							</div>
							{validatePay ? (
								<div className={styles.payInfo}>
									<img
										src={validateImg}
										alt="Validating"
										className={styles.successImg}
									/>
									<PageLoader
										loading={loading2}
										title="Your payment is being validated"
									/>
								</div>
							) : (
								<>
									{timedOut ? (
										<div className={styles.payInfo}>
											<div className={styles.payInfo__main}>
												<div className={styles.payInfo__main_one}>
													<MimaText align="center" color="var(--color-error)">
														The account number has expired and this transaction
														has timed out. If your transfer is not completed
														yet, kindly restart the process after 3 minutes.
													</MimaText>
												</div>
											</div>
										</div>
									) : (
										<>
											{accounts
												?.filter(x => {
													return x.bank === chooseBank;
												})
												?.map(account => (
													<div className={styles.payInfo} key={account._id}>
														<MimaText
															align="center"
															mb={2}
															variant="subtitleBold">
															Transfer{' '}
															<span className={styles.span}>
																{amountFormatter('NGN').format(
																	invoice?.deposit +
																		(invoice.customerProcessingFee || 0)
																)}
															</span>
															<br />
															to {account.accountName}
														</MimaText>
														<div className={styles.payInfo__main}>
															<div className={styles.payInfo__nav}>
																<MimaText variant="smallBold">
																	PAY WITH
																</MimaText>
																{bankList.map((bank, i) => (
																	<div
																		className={`${styles.payInfo__nav_item} ${chooseBank === bank ? styles.payInfo__nav_active : ''}`}
																		onClick={() => {
																			setChooseBank(bank);
																		}}
																		key={bank}>
																		{bank}
																	</div>
																))}
															</div>
															<div className={styles.payInfo__main_text}>
																<MimaText
																	variant="bodyBold"
																	mb={1}
																	align="center">
																	{account.bank} Bank
																</MimaText>
																<MimaText
																	variant="h3"
																	align="center"
																	style={{ display: 'flex' }}>
																	{account.accountNumber}{' '}
																	<MdOutlineContentCopy
																		style={{ marginLeft: '1rem' }}
																		onClick={() => {
																			navigator.clipboard.writeText(
																				account.accountNumber
																			);
																			MimaToastUtil.success({
																				message: 'Copied!',
																			});
																		}}
																	/>
																</MimaText>
																<MimaText variant="small" mt={1} align="center">
																	Use this account for this transaction only
																</MimaText>

																<MimaText
																	color="var(--color-error)"
																	variant="small"
																	align="center"
																	mt={2}>
																	Account Expires in{' '}
																	<span
																		className={styles.span}
																		style={{
																			color: 'var(--color-error)',
																			fontSize: '1.5rem',
																		}}>
																		{timeLeft}
																	</span>{' '}
																	mins
																</MimaText>
															</div>
														</div>
														<MimaButton
															buttonColor="var(--color-dark)"
															title="Validate Payment"
															mt={2}
															onClick={validatePaymentClick}
														/>
													</div>
												))}
										</>
									)}
								</>
							)}
							<MimaText align="center" mt={7}>
								Powered by Mima <br />
								Visit{' '}
								<a
									className={styles.a}
									href="https://www.trymima.com/signup"
									target="_blank"
									rel="noreferrer">
									trymima.com/signup
								</a>{' '}
								to get started
							</MimaText>
						</div>
					)}
				</>
			)}
		</>
	);
};

export default MimaCheckout;
